import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import LeadGenerationExpandModule from 'components/organisms/social/LeadGenerationExpandModule';

class LeadGenerationContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'LEAD_GENERATION' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialAdsByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
    }

    render() {
        const { hide, showSemCpconv, showConversionRevenue } = this.props;
        return (
            !hide ?
                <LeadGenerationExpandModule module={this.props.module}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    layer={this.props.layer}
                    layerTwo={this.props.layerTwo}
                    entityMeta={this.props.entityMeta}
                    showSemCpconv={showSemCpconv}
                    showConversionRevenue={showConversionRevenue}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                /> : null
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.LEAD_GENERATION,
    layerTwo: state.layerTwo,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    showSemCpconv: get(state, 'entities.meta.meta.showSemCpconv', false),
    showConversionRevenue: get(state, 'entities.meta.meta.showConversionRevenue', false),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default withRouter(
    connect(mapStateToProps, {
        fetchSocialActionsByObjective,
        fetchSocialAdsByObjective,
        fetchSocialAdSetsByObjective,
        fetchSocialCampaignsByObjective,
        fetchSocialDataByObjective,
    })(LeadGenerationContainer));



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/LeadGenerationExpandContainer.js